export const getAttendance = (attendanceId) => ({
  attendanceReports: { reportsList },
}) => reportsList.find(({ id }) => id === +attendanceId);

export const getSummaryAttendance = (attendanceId) => ({
  attendanceReports: { reportsSummeryList },
}) => reportsSummeryList.find(({ id }) => id === +attendanceId);
